import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { tenantInterceptor } from './tenant.interceptor';
import { langInterceptor } from './lang.interceptor';
import { ApiService } from './api.service';

export const provideHttp = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideHttpClient(withInterceptors([tenantInterceptor, langInterceptor])),
    provideEnvironmentInitializer(() => inject(ApiService)),
  ]
};
